import { Formik } from 'formik';
import * as Yup from 'yup';
import { Product } from '../types/product';
import InputFormik from './formik/InputFormik';
import UrlInputFormik from './formik/UrlInputFormik';
import ChevronDownOutline from './icons/ChevronDownOutline';
import ChevronRightOutline from './icons/ChevronRightOutline';
import Button from './ui/Button';

type ProductUpdate = {
  name: string;
  price?: number;
  comment?: string;
  url?: string;
  imageUrl?: string;
};

type ProductFormProps = {
  isLoading: boolean;
  product?: Product;
  onSubmit: (update: ProductUpdate) => void;
  submitText: string;
  type: 'wish' | 'idea';
};

const ProductSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Drei Buchstaben sollten es schon sein! 🙄')
    .max(40, 'Geht das auch ein bisschen kürzer? 😉')
    .required('Bitte gib einen Namen an.'),
  price: Yup.number(),
  comment: Yup.string().max(250, 'Geht das auch ein bisschen kürzer? 😉'),
  url: Yup.string().url('Bitte gib eine valide URL an.'),
});

const ProductForm = (props: ProductFormProps) => {
  return (
    <Formik
      initialValues={
        props.product
          ? {
            name: props.product.name,
            price: props.product.price ? String(props.product.price) : '',
            comment: props.product.comment || '',
            url: props.product.url || '',
            imageUrl: props.product.imageUrl || '',
            isExpanded: true,
          }
          : { name: '', price: '', comment: '', url: '', imageUrl: '', isExpanded: false }
      }
      onSubmit={(values) => {
        props.onSubmit({
          name: values.name,
          price: values.price && values.isExpanded ? parseFloat(values.price) : undefined,
          comment: (values.isExpanded && values.comment) || undefined,
          url: (values.isExpanded && values.url) || undefined,
          imageUrl: (values.isExpanded && values.imageUrl) || undefined,
        });
      }}
      validationSchema={ProductSchema}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <InputFormik
                name="name"
                label="Name"
                placeholder={props.type === 'wish' ? 'Was wünscht du dir?' : 'Was hast du für eine Idee?'}
                isRequired
                autoFocus
              />
              <p>
                <a
                  href=" "
                  onClick={(e) => {
                    e.preventDefault();
                    setFieldValue('isExpanded', !values.isExpanded);
                  }}
                  className="inline-flex items-center font-medium text-blue-600 dark:text-blue-500 hover:underline"
                >
                  {values.isExpanded ? <ChevronDownOutline /> : <ChevronRightOutline />}{' '}
                  {values.isExpanded ? 'Weniger Details' : 'Mehr Details'}
                </a>
              </p>
              {values.isExpanded && (
                <>
                  <InputFormik
                    name="price"
                    label="Preis"
                    endAdornment="€"
                    placeholder="Was kostet es ungefähr?"
                    type="number"
                  />
                  <InputFormik
                    name="comment"
                    label="Anmerkungen"
                    placeholder="Hast du noch weitere Anmerkungen?"
                    isTextArea
                  />
                  <UrlInputFormik
                    name="url"
                    imageFieldName="imageUrl"
                    label="Link"
                    placeholder="Hast du noch einen Link zum Produkt?"
                  />
                </>
              )}
              <span className="mb-1" />
              {/* <TagInputFormik name="tags" label="Tags" /> */}
              <Button type="submit" isLoading={props.isLoading}>
                {props.submitText}
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default ProductForm;
